import React from "react";

const Header = () => {
  return (
    <header className="bg-white shadow-md py-5 px-8 flex items-center justify-between fixed top-0 left-0 right-0 z-30 mb-10 ml-64 h-20">
      <h1 className="text-xl font-semibold text-gray-800">Welcome to NCCF Dashboard</h1>
    </header>
  );
};

export default Header;
